import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import {
  ArrowLeft,
  ChevronUp,
  // List,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import apiHandler from "../common/api";
import CommonReactSelect from "../common/CommonReactSelect";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useCheckUserPermission } from "../common/userPermission";
import LoadingSpinner from "../../InitialPage/Sidebar/LoadingSpinner";

const PortalPermissions = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const navigator = useNavigate();

  const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);

  const uPermisson = useSelector((state) => state.userpermission);
  console.log(uPermisson, "uPermisson");

  const [selectedUserId, setSelectedUserId] = useState(0);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [permissionUserListByLogin, setPermissionUserListByLogin] = useState(
    []
  );
   const [loading, setLoading] = useState(false);

  const userWisePermission = async (id) => {
    await apiHandler({
      method: "GET",
      route: "auth/getuserpermission",
      payload: { userId: id },
    })
      .then((response) => {
        console.log(response.ResponseData, "userpermission");
        setSelectedPermissions(
          response.ResponseData.map((p) => p?.permissionId)
        );
      })
      .catch((error) => {
        console.error("Error fetching user permissions:", error);
      });
  };

  useEffect(() => {
    if (selectedUserId > 0) {
      userWisePermission(selectedUserId);
    } else {
      userList();
    }
  }, [selectedUserId]);

  // Group permissions by moduleName
  const groupedPermissions = uPermisson.reduce((acc, permission) => {
    if (!acc[permission.moduleName]) {
      acc[permission.moduleName] = [];
    }
    acc[permission.moduleName].push(permission);
    return acc;
  }, {});

  const handleCheckboxChange = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const handleSelectChange = (e) => {
    setSelectedUserId(e ? e.value : 0);
  };

  const userList = async () => {
    await apiHandler({
      method: "GET",
      route: "users/userslist",
      payload: {
        businessUniqueName: userData?.businessUniqueName,
      },
    })
      .then((response) => {
        console.log("User List:", response.ResponseData);
        setPermissionUserListByLogin(response.ResponseData);
      })
      .catch((error) => {
        console.error("Error fetching user list:", error);
      });
  };

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (e) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You want to save this changes!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, Save it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleSubmit(e);
        MySwal.fire({
          title: "Submited!",
          text: "User Permission has been Saved.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Selected Permission IDs:", selectedPermissions);

    await apiHandler({
      method: "POST",
      route: "auth/updateuserpermission",
      payload: { userId: selectedUserId, permissions: selectedPermissions },
    })
      .then((response) => {
        console.log("Permissions updated successfully:", response.data);
        setLoading(false);
        setSelectedUserId(0);
        setSelectedPermissions([]);
      })
      .catch((error) => {
        console.error("Error updating permissions:", error);
        setLoading(false);
      });
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleSelectAll = () => {
    if (selectedPermissions.length === uPermisson.length) {
      setSelectedPermissions([]);
    } else {
      setSelectedPermissions(uPermisson.map((p) => p.permissionId));
    }
  };

  const handleSectionSelectAll = (moduleName) => {
    const sectionPermissions = groupedPermissions[moduleName].map(
      (p) => p.permissionId
    );
    const isAllSelected = sectionPermissions.every((id) =>
      selectedPermissions.includes(id)
    );

    if (isAllSelected) {
      setSelectedPermissions((prev) =>
        prev.filter((id) => !sectionPermissions.includes(id))
      );
    } else {
      setSelectedPermissions((prev) => [
        ...new Set([...prev, ...sectionPermissions]),
      ]);
    }
  };

  return (
    <>
    <LoadingSpinner isLoading={loading} />
    <div className="page-wrapper">
      <div className="content">
        <div className="d-flex flex-wrap page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Permission</h4>
              <h6>Manage User Permissions</h6>
            </div>
          </div>
          <ul className="d-flex ms-auto flex-wrap table-top-head">
            <li>
              <CommonReactSelect
                options={permissionUserListByLogin}
                placeholder="Select for permissions"
                value={
                  selectedUserId > 0
                    ? permissionUserListByLogin?.find(
                        (el) => el.value === selectedUserId
                      )
                    : null
                }
                onChange={handleSelectChange}
                required={true}
              />
            </li>
            {useCheckUserPermission(route.permissiontemplate) && (
              <li>
                <div className="page-btn">
                  <button
                    onClick={() => navigator(route.permissiontemplate)}
                    className="1 btn btn-primary btn-md btn-wave me-2"
                  >
                    <ArrowLeft className="me-2" />
                    Permission Template
                  </button>
                </div>
              </li>
            )}
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <form>
          <div className="card">
            <div className="card-body add-product pb-0">
              <label className="custome-border-top pb-3 checkboxs col-auto">
                <input
                  type="checkbox"
                  checked={selectedPermissions.length === uPermisson.length}
                  onChange={handleSelectAll}
                />
                <span className="checkmarks" />
                Select All Permissions
              </label>
              {Object.entries(groupedPermissions).map(
                ([moduleName, permissions], index) => (
                  <>
                      <input
                                  type="checkbox"
                                  onClick={(event) => event.stopPropagation()}
                                  checked={permissions.every((p) =>
                                    selectedPermissions.includes(p.permissionId)
                                  )}
                                  onChange={(event) => {
                                    event.stopPropagation(); // Prevent accordion toggle
                                    handleSectionSelectAll(moduleName);
                                  }}
                                /><span style={{fontSize:"16px", marginLeft:"12px"}} className="ml-2"> Select All</span>
                    <div
                    key={index}
                    className="custome-border-top accordion-card-one accordion"
                    id={`heading-${index}`}
                  >
                    <div className="accordion-item">
                      <div className="accordion-header" id={`heading-${index}`}>
                        <div
                          className="accordion-button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-${index}`}
                          aria-controls={`collapse-${index}`}
                        >
                          <div className=" text-editor add-list">
                            <div style={{border:"none"}} className="addproduct-icon m-0 p-0 list">
                              <div className="d-flex">
                                <h5>
                                  <label style={{paddingLeft:"0px"}}
                                    className="checkboxs col-auto"
                                    onClick={(event) => event.stopPropagation()} // Prevent accordion toggle when clicking label
                                  >
                                    <span className="checkmarks" />
                                     {moduleName} Permission
                                  </label>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id={`collapse-${index}`}
                        className="accordion-collapse collapse show"
                        aria-labelledby={`heading-${index}`}
                        data-bs-parent="#permissionAccordion"
                      >
                        <div className="accordion-body">
                          <div className="text-editor add-list add">
                            <div className="custom-filed">
                              <div className="input-block add-lists row w-100">
                                {permissions.map((permission) => (
                                  <label
                                    className="checkboxs col-auto"
                                    key={permission.permissionId}
                                    onClick={(event) => event.stopPropagation()} // Prevent accordion toggle when clicking label
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedPermissions.includes(
                                        permission.permissionId
                                      )}
                                      onChange={(event) => {
                                        event.stopPropagation(); // Prevent accordion toggle
                                        handleCheckboxChange(
                                          permission.permissionId
                                        );
                                      }}
                                    />
                                    <span className="checkmarks" />
                                    {permission.permissionName}
                                  </label>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </>
                
                )
              )}
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button
                type="button"
                className="btn btn-outline-primary btn-md me-2"
                onClick={() => {
                  setSelectedUserId(0);
                  setSelectedPermissions([]);
                }}
              >
                Cancel
              </button>
              {selectedUserId > 0 && (
                <Link
                  to="#"
                  className="2 btn btn-primary btn-md btn-wave me-2"
                  onClick={showConfirmationAlert} // handleSubmit
                >
                  Save
                </Link>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
    </>
  );
};

export default PortalPermissions;
